import * as React from "react"
import SEOHead from "../components/head"
import Soon from "../components/soon"

export default function NoFound() {
  return <Soon />
}

export const Head = () => {
  return <SEOHead title="Bumbershoot" />
}